// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1nbUX","label":"SetPasswdForm_label__3sGd9"};